import React from "react";
import { Link } from "react-router-dom";
import { FiArrowLeft, FiAlertCircle } from "react-icons/fi";

const NotFound: React.FC = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 dark:bg-slate-950 px-4">
      <div className="text-center max-w-sm">
        <div className="w-14 h-14 rounded-xl bg-red-50 dark:bg-red-500/10 flex items-center justify-center mx-auto mb-5">
          <FiAlertCircle size={28} className="text-red-500 dark:text-red-400" />
        </div>
        <h1 className="text-5xl font-bold text-slate-900 dark:text-white mb-2">404</h1>
        <p className="text-base font-medium text-slate-700 dark:text-slate-300 mb-1">
          Page not found
        </p>
        <p className="text-sm text-slate-500 dark:text-slate-400 mb-6">
          The page you are looking for does not exist or has been moved.
        </p>
        <Link
          to="/"
          className="inline-flex items-center gap-2 px-5 py-2.5 bg-primary-500 hover:bg-primary-600 text-white text-sm font-medium rounded-lg transition-colors"
        >
          <FiArrowLeft size={16} />
          Back to Home
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
